import React from 'react';
import { hidden, tablet_block } from 'scy/display.mod.scss';
import margin from 'scy/margin.mod.scss';

const FilterContainer = React.forwardRef(({ children }, ref) => (
  <div className={`${hidden} ${tablet_block} ${margin.sm}`} ref={ref}>
    {children}
  </div>
));

export default FilterContainer;
